var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-checkbox-input',{staticClass:"custom-control custom-checkbox stores-list-checkbox",attrs:{"name":`${_vm.checkboxName}-${_vm.rowId}`,"disabled":_vm.amIDisabled},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }